import { useContext } from 'react';
import { popperReferenceContext } from './context';

export const usePopperReference = () => {
  const popperReference = useContext(popperReferenceContext);
  return popperReference;
};
